<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="columns is-gapless center">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('addSecteurLien.addPopUp.title') }}
            </h1>
          </div>
        </div>
        <error-msg-component  :messages="messagesError"
                              :error="error"/>
        <div class="columns mgt-20px">
          <div class="column is-6">
            <b-field
              :label="$t('addSecteurLien.addPopUp.secteurTypes')"
            >
              <b-select v-model="selectedSecteurType" expanded>
                <option :value="null"></option>
                <option
                  v-for="secteurType in secteurTypes"
                  :key="secteurType.code"
                  :value="secteurType.code">
                  {{$t(secteurType.libelle)}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field
              class="obligatoire"
              :label="$t('addSecteurLien.addPopUp.secteur')"
            >
              <b-select v-model="selectedSelecteur" expanded>
                <option :value="null"></option>
                <option
                  v-for="secteur in filteredSecteur"
                  :key="secteur.id"
                  :value="secteur.id">
                  {{secteur.libelle}}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
        <footer class="pdt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="addSecteurUtilisateur">
                {{ $t('general.button.valider')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import { SECTEUR_TYPE } from '@/configuration/parametrage/secteurConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validation from '@/services/secteur/validationSecteur';

export default {
  props: {
    secteurs: {
      type: Array,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      selectedSecteurType: null,
      secteurTypes: SECTEUR_TYPE,
      selectedSelecteur: null,
      messagesError: [],
      error: false,
    };
  },
  computed: {
    filteredSecteur() {
      return this.selectedSecteurType
        ? this.secteurs
          ?.filter(secteur => secteur.type === this.selectedSecteurType && secteur.actif === true)
        : this.secteurs?.filter(secteur => secteur.actif === true);
    },
  },
  methods: {
    addSecteurUtilisateur() {
      this.error = false;
      this.messagesError = [];
      if (this.selectedSelecteur) {
        this.$emit('addSecteur', this.secteurs.find(secteur => secteur.id === this.selectedSelecteur));
        this.$parent.close();
      } else {
        validation(this.selectedSelecteur, this.messagesError);
        this.error = true;
      }
    },
  },
};
</script>
